export default __webpack_public_path__ + "static/media/hrconnect-logo.7d4fb9f0.svg";